import React, { useEffect, useState } from "react";

//react-redux
import { useSelector, connect, useDispatch } from "react-redux";

//routing
import { Link } from "react-router-dom";
import Male from "../../../assets/images/male.png";

import { getSetting } from "../../../store/setting/action";

//dayjs
import dayjs from "dayjs";

import arraySort from "array-sort";

import ReasonDialogue from "./ReasonDialogue";
import Pagination from "../../../pages/Pagination";
import BonusPaneltyDialogue from "./BonusPaneltyDialogue";
import { getAgencyRedeem } from "../../../store/agencyRedeem/action";
import { OPEN_BONUS_PANELTY_DIALOGUE, OPEN_REASON_DIALOGUE } from "../../../store/agencyRedeem/type";


//sweet alert

const TablePaginationActions = React.lazy(() => import("../TablePagination"));

const PendingRedeem = () => {
  const dispatch = useDispatch();
  const { agencyRedeem, total } = useSelector((state) => state.agencyRedeem);
  const setting = useSelector((state) => state.setting.setting);

  const [coinSort, setCoinSort] = useState(true);
  const [data, setData] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    dispatch(getSetting());
    dispatch(getAgencyRedeem("pending", activePage, rowsPerPage));
  }, [dispatch, activePage, rowsPerPage]);

  useEffect(() => {
    setData(agencyRedeem);
  }, [agencyRedeem]);

  //   pagination

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toUpperCase()
      ? e.target.value.trim().toUpperCase()
      : e.target.value.trim();
    if (value) {
      const data = agencyRedeem.filter((data) => {
        return (
          data?.userId?.name?.toUpperCase()?.indexOf(value) > -1 ||
          data?.paymentGateway?.toUpperCase()?.indexOf(value) > -1 ||
          data?.description?.toUpperCase()?.indexOf(value) > -1 ||
          data?.rCoin?.toString()?.indexOf(value) > -1 ||
          data?.agency?.agencyCode?.toString()?.indexOf(value) > -1 ||
          data?.agency?.uniqueId?.toString()?.indexOf(value) > -1
        );
      });
      setData(data);
    } else {
      return setData(agencyRedeem);
    }
  };
  const handleAcceptDecline = (id, type) => {
    dispatch({ type: OPEN_BONUS_PANELTY_DIALOGUE, payload: { id, type } });
  };

  const handleDecline = (id, type) => {
    dispatch({ type: OPEN_REASON_DIALOGUE, payload: { id, type } });
  };
  const handleCoinSort = () => {
    setCoinSort(!coinSort);
    arraySort(data, "rCoin", { reverse: coinSort });
  };

  return (
    <>
      <div class="row">
        <ReasonDialogue />
        <BonusPaneltyDialogue />
        <div class="col">
          <div class="card">
            <div className="card-header pb-0">
              <div className="row my-3">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left"></div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right">
                  <form action="">
                    <div className="input-group mb-3 border rounded-pill">
                      <div className="input-group-prepend border-0">
                        <div id="button-addon4" className="btn text-danger">
                          <i className="fas fa-search mt-2"></i>
                        </div>
                      </div>
                      <input
                        type="search"
                        placeholder="What're you searching for?"
                        aria-describedby="button-addon4"
                        className="form-control bg-none border-0 rounded-pill searchBar"
                        onChange={handleSearch}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="card-body card-overflow">
              <div class="d-sm-flex align-items-center justify-content-between mb-4"></div>

              <table class="table table-striped">
                <thead className="text-white">
                  <tr>
                    <th>No.</th>
                    <th>Agency</th>
                    <th>Agency Code</th>
                    <th>Bonus Or Penalty</th>
                    <th>Payment Gateway</th>
                    <th>Description</th>
                    <th onClick={handleCoinSort} style={{ cursor: "pointer" }}>
                      RCoin {coinSort ? " ▼" : " ▲"}
                    </th>
                    <th>
                      {setting.currency === "£"
                        ? "GBP(£)"
                        : setting.currency === "$"
                        ? "Dollar($)"
                        : "Rupee(₹)"}
                    </th>
                    <th>CreatedAt</th>
                    <th>Accept</th>
                    <th>Decline</th>
                  </tr>
                </thead>
                <tbody className="t">
                  {data?.length > 0 ? (
                    data.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{(activePage - 1) * rowsPerPage + index + 1}</td>
                          <td>
                            <span className="d-flex align-items-center">
                              {data?.agency?.name ? data?.agency?.name : "-"}
                            </span>
                          </td>
                          <td>{data?.agency?.agencyCode}</td>

                        
                          <td>
                            {data?.bonus === 0 ? (
                              <span className="text-danger">
                                {data?.penalty}
                              </span>
                            ) : data?.penalty === 0 ? (
                              <span className="text-success">
                                {data?.bonus}
                              </span>
                            ) : (
                              0
                            )}
                          </td>
                          <td>{data.paymentGateway || "-"}</td>
                          <td>{data.description || "-"}</td>
                          <td>{data.rCoin || 0}</td>
                          <td>{data?.amount || 0}</td>
                          <td>
                            {dayjs(data.createdAt).format("DD MMM, YYYY")}
                          </td>
                          <td>
                            <button
                              class="btn btn-sm text-white success"
                              onClick={() =>
                                handleAcceptDecline(data._id, "accept")
                              }
                            >
                              <i class="fa fa-check"></i> Accept
                            </button>
                          </td>
                          <td>
                            <button
                              class="btn btn-sm text-white danger"
                              onClick={() =>
                                handleDecline(data?._id, "decline")
                              }
                            >
                              <i class="fas fa-times"></i> Decline
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="14" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={total}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingRedeem;
